import {
    getActiveReports,
    getBusinessSources,
    getBusinessSourcesToAccountTypeMapping,
    objToArr,
} from 'utils/helperMethods';
import PaymentGatewayCredentialList from './models/PaymentGatewayCredentialList';
import {
    CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR,
    CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
    CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS,
    FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_ERROR,
    FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_REQUEST,
    FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_SUCCESS,
    FETCH_PAYMENT_GATEWAY_CREDENTIALS_FAILURE,
    FETCH_PAYMENT_GATEWAY_CREDENTIALS_REQUEST,
    FETCH_PAYMENT_GATEWAY_CREDENTIALS_SUCCESS,
    GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR,
    GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST,
    GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS,
    GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR,
    GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS,
    RESET_PAYMENT_GATEWAY_CREDENTIAL_CREATE_FORM,
    RESET_PAYMENT_GATEWAY_CREDENTIAL_EDIT_DATA_ON_CREATE_FORM,
    RESET_PAYMENT_GATEWAY_CREDENTIAL_UPDATE_FORM,
    UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR,
    UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST,
    UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS,
    HIDE_ROLE_LOADER,
    SHOW_ROLE_LOADER,
    FETCH_FORM_DATA_PRICING_SECTION_FAILED,
    FETCH_FORM_DATA_PRICING_SECTION_SUCCESS,
    CLICKED_CREATE_PAYMENT_CREADENTIAL_FORM
} from './paymentGatewayCredentials.constants';
import { getSelectedPayModePGMID, getSlabData } from '../constants';
const payModeToPricingMapping = {
    debitCard: ['Domestic-Debit-Card', 'Foreign-Debit-Card'],
    creditCard: ['Domestic-Credit-Card', 'Foreign-Credit-Card'],
    // upi: ['UPI'],
    wallets: ['Wallets'],
    netbanking: ['Net-Banking'],
};

const getSelectedPayMode = paymentModeData => {
    // console.log("payment mode data", paymentModeData);
    const selectedMode = {};
    const creditCardBusinessSource = paymentModeData.creditCardBusinessSource;
    const debitCardBusinessSource = paymentModeData.debitCardBusinessSource;

    const mapbusinessSource = {
        debitCard: debitCardBusinessSource,
        creditCard: creditCardBusinessSource
    }

    const mapBusinessTypes = (type) => {
        if (type === 'INTERNATIONAL') return 'foreign';
        return type;
    }

    const isBoolSelected = (type, paymentType) => {
        // console.log("is bool selected", type, paymentType);
        let businessSource = mapbusinessSource[paymentType];
        // console.log('business', businessSource);
        let isItemConsider = false;
        if (businessSource?.length) {
            businessSource.map(item => {
                // console.log("..asdfsafd", type.toLowerCase(), item, mapBusinessTypes(item).toLowerCase(), isItemConsider);
                if (!isItemConsider)
                    isItemConsider = type?.toLowerCase()?.includes(mapBusinessTypes(item)?.toLowerCase());
            })
        } else {
            isItemConsider = true;
        }
        // console.log("frina;;", isItemConsider);
        return isItemConsider;
    }

    paymentModeData && Object.keys(paymentModeData).map(item => {
        if (payModeToPricingMapping[item] && paymentModeData[item].length > 0) {
            // console.log("paymennnt", paymentModeData);
            payModeToPricingMapping[item].map((paymentMode, idddxxx) => {
                // console.log("patcheck", paymentMode, idddxxx);
                if (isBoolSelected(paymentMode, item)) {
                    // console.log(".........ssss", paymentMode);
                    selectedMode[paymentMode] = [{...getSelectedPayModePGMID(paymentMode)}];
                }
            });
        }
    });

    return selectedMode;
};

const getPricingInitValue = formSectionData => {
    // console.log("form section data", formSectionData);
    const selectedPayMode = getSelectedPayMode({...formSectionData});
    // console.log("select pay mode", selectedPayMode);
    const finalSelectedPayMode = {...selectedPayMode};
    Object.keys(selectedPayMode).map((paymode, index) => {
        let modeDetails = selectedPayMode[paymode][0];
        // console.log("mode details", modeDetails);
        // console.log("pay mode", paymode);
        selectedPayMode[paymode].map((item, index) => {
            finalSelectedPayMode[paymode][index].bankSlabs = getSlabData(
                modeDetails,
                modeDetails.isSingleSlab
            );
        });
    });

    return finalSelectedPayMode;
};

const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    isLoading: false,
    generatedFile: {
        isSuccess: false,
        error: {},
    },
    activeReports: {
        reports: {},
        error: {},
    },
    downloadReport: {},
    draftData: [],
    createFormData: {
        isLoading: false,
        isSuccess: false,
    },
    editFormData: {
        isLoading: false,
        isSuccess: false,
    },
    pricing_section_initial_data: {
        isSuccess: false
    }
};

const getOnboardingFormValuesFromResponse = values => {
    const {
        category_name,
        sub_category_name,
        mcc,
        credentials,
        payment_modes,
        pg_code,
    } = values;

    const onboardingInitialData = {
        pgName: pg_code,
        category: category_name,
        sub_category_name,
        mcc,
        credentials,
    };
    return onboardingInitialData;
};

const getPaymodeFormValuesFromResponse = values => {
    if (values && values.length) {
        const paymentMode = values || [];
        const creditCard = [];
        const debitCard = [];
        const netbanking = [];
        const upi = [];
        let debitCardBusinessSource = [];
        let creditCardBusinessSource = [];
        let upiBusinessSource = [];
        let upiAccountType = [];
        const wallets = [];
        const accountVerification = [];
        const emi = [];
        let emiBusinessSource = [];
        const mandateUpi = [];
        let vpa = '';

        // console.log("values", paymentMode);

        paymentMode.forEach(item => {
            // console.log("Processing item", item); // Log each item to debug

            if (!item) {
                return;
            }
            if (item.paymentType === 'CC') {
                creditCard.push(item.paymentModeInfo);
                creditCardBusinessSource = item ? getBusinessSources(item) : [];
            }
            if (item.paymentType === 'DC') {
                debitCard.push(item.paymentModeInfo);
                debitCardBusinessSource = item ? getBusinessSources(item) : [];
            }
            if (item.paymentType === 'NB') {
                netbanking.push(item.paymentModeInfo);
            }
            if (item.paymentType === 'UPI' && item.category !== 'MANDATE') {
                upi.push(item.paymentModeInfo);
                vpa = item.paymentSubModeInfo;
                upiBusinessSource = item ? getBusinessSources(item) : [];
                upiAccountType = item.txnConfig
                    ? getBusinessSourcesToAccountTypeMapping(item.txnConfig)
                    : [];
            }
            if (item.paymentType === 'UPI' && item.category === 'MANDATE') {
                mandateUpi.push(item.paymentModeInfo);
            }
            if (item.paymentType === 'WALLET') {
                wallets.push(item.paymentModeInfo);
            }
            if (item.paymentType === 'ACCOUNT_VERIFICATION') {
                accountVerification.push(item.paymentModeInfo);
            }
            if (item.paymentType === 'EMI_CC') {
                emi.push(item.paymentModeInfo);
                emiBusinessSource = item ? getBusinessSources(item) : [];
            }
        });
        let data = {
            debitCard,
            creditCard,
            netbanking,
            upi,
            mandateUpi,
            debitCardBusinessSource,
            creditCardBusinessSource,
            upiBusinessSource,
            ...upiAccountType,
            wallets,
        };

        // console.log("getPaymodeFormValuesFromResponsedata", data);
        return data
    }
    return {};
};

function updateInitData(initData, editBankSlabData) {
    try {

        const respUpdateInitData={};
        // console.log("hehheh");
        console.log("init data....", initData, editBankSlabData);

        Object.keys(initData).map(initDataPayModKey => {
            // console.log("keys pay mode", initDataPayModKey);
            respUpdateInitData[initDataPayModKey] = [];
            initData[initDataPayModKey].map(payModData => {
                // console.log("till---> pay mode");
                // filteredEditSlabData -  contained clubbed response (basis of cardType) from feeConfigList
                const filteredEditSlabData = {};
                // filtering response data
                Object.values(editBankSlabData)
                .filter(item => {
                    let isDomestic = payModData.isDomestic ? 1 : 0;
                    return item.paymentType === payModData.paymentType && isDomestic == item.domesticFlag
                })
                .map(item => {
                    let uniqueCode = 'all';

                    // item card type represents the dropdown in pgmid page
                    if (['NB', 'WALLET'].includes(item.paymentType) && item.issuer) {
                        uniqueCode = item.issuer;
                        item.cardType = item.issuer;
                    }
                    if (item.cardType) {
                        uniqueCode = item.cardType;
                        if (item.cardCategory) {
                            uniqueCode = uniqueCode + item.cardCategory;
                        }
                    } else {
                        item.cardType = 'all'
                    }
                    // clubbing the slab
                    if (!filteredEditSlabData[uniqueCode]) {
                        filteredEditSlabData[uniqueCode] = [{...item}];
                    } else {
                        filteredEditSlabData[uniqueCode].push({...item});
                    }
                });

                // console.log("filtered edit slab data", filteredEditSlabData);
                // setting response data
                if (Object.keys(filteredEditSlabData).length) {
                    Object.entries(filteredEditSlabData).forEach(([filteredEditDataKey, filteredEditDataItem]) => {
                        // console.log("filteredEditDataItem", filteredEditDataItem);
                        let cardType = filteredEditDataKey;
                        let sectionSlabData = {...payModData, cardType};
                        // for adding all the keys in the response
                        sectionSlabData.bankSlabs = [...filteredEditDataItem];
                        respUpdateInitData[initDataPayModKey].push(sectionSlabData);
                    })
                } else {
                    respUpdateInitData[initDataPayModKey].push(payModData);
                }
            })
        })

        console.log("updated init data", respUpdateInitData);
        return respUpdateInitData;
        function pairSlabs(data) {
            
            if(data["Domestic-Debit-Card"]){
                const bankSlabs = data["Domestic-Debit-Card"][0].bankSlabs;
                const grouped = {};
                // Group by paySlabId
                bankSlabs.forEach(slab => {
                    const { paySlabId } = slab;
                    if (!grouped[paySlabId]) {
                        grouped[paySlabId] = [];
                    }
                    grouped[paySlabId].push(slab);
                });
                console.log("bankSlabsbankSlabs", bankSlabs, grouped);

                const newDoData = [];

                Object.keys(grouped).map(item => {
                    newDoData.push({...data["Domestic-Debit-Card"][0], bankSlabs: grouped[item] });
                })
                data["Domestic-Debit-Card"] = newDoData;
                console.log(newDoData, "newDoDatanewDoData");
            }
            if(data["Foreign-Debit-Card"]){
                const bankSlabs = data["Foreign-Debit-Card"][0].bankSlabs;
                const grouped = {};
                // Group by paySlabId
                bankSlabs.forEach(slab => {
                    const { paySlabId } = slab;
                    if (!grouped[paySlabId]) {
                        grouped[paySlabId] = [];
                    }
                    grouped[paySlabId].push(slab);
                });
                console.log("bankSlabsbankSlabs", bankSlabs, grouped);

                const newDoData = [];

                Object.keys(grouped).map(item => {
                    newDoData.push({...data["Foreign-Debit-Card"][0], bankSlabs: grouped[item] });
                })
                data["Foreign-Debit-Card"] = newDoData;
                console.log(newDoData, "newDoDatanewDoData");
            }
            console.log("returned data....", data);
            return data;
        }
        // console.log(pairSlabs(respUpdateInitData), "respUpdateInitData");
        return pairSlabs(respUpdateInitData);
    } catch(e) {
        // console.log("no error message ....", e.message);
        return {};
    }
}

const getPricingFormValuesFromResponse = (
    payModeData,
    pgMIDFeeInfoResponse
) => {
    const initPricingValue = getPricingInitValue(payModeData);
    // console.log("init pricing value", initPricingValue);
    // const editInitPricingValue = updateInitData(
    const editInitPricingValue = pgMIDFeeInfoResponse?.pgMidFeeConfigInfoList && updateInitData(
        {...initPricingValue},
        {...pgMIDFeeInfoResponse?.pgMidFeeConfigInfoList}
    );

    console.log("edit and fetch init pricing value", editInitPricingValue);

    let pricingInitData = {
        feeConfigList: {...editInitPricingValue},
    };

    return pricingInitData;
};

const getEditDraftData = data => {
    let draftData = [];
    // console.log("Edit data", data);
    let onboardingInitialData = getOnboardingFormValuesFromResponse(
        data.infoResponse
    );
    // console.log("on boarding data", onboardingInitialData);

    if (onboardingInitialData) {
        draftData.push({
            data: onboardingInitialData,
            type: 'credentialSection',
        });
    }

    let payModeData = getPaymodeFormValuesFromResponse(
        data?.infoResponse?.payment_modes
    );
    // console.log("pay mode data", payModeData);

    if (payModeData) {
        draftData.push({
            data: payModeData,
            type: 'paymodeSection',
        });
    }

    // let pricingInitData = getPricingFormValuesFromResponse(
    let pricingInitData = data?.pgMIDFeeInfoResponse && getPricingFormValuesFromResponse(
        {...payModeData},
        {...data.pgMIDFeeInfoResponse}
    );

    // console.log("pricing init data", pricingInitData);

    if (pricingInitData) {
        draftData.push({
            data: pricingInitData,
            type: 'pricingSection',
        });
    }
    return draftData;
};

export const paymentGatewayCredentialsReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_PAYMENT_GATEWAY_CREDENTIALS_REQUEST: {
            return { ...state, tableData: [], isLoading: true };
        }

        case FETCH_PAYMENT_GATEWAY_CREDENTIALS_SUCCESS: {
            const createRefundData = new PaymentGatewayCredentialList(
                action.payload
            );
            return {
                ...state,
                ...createRefundData,
                error: {},
                isLoading: false,
            };
        }

        case FETCH_PAYMENT_GATEWAY_CREDENTIALS_FAILURE: {
            return {
                ...state,
                error: {
                    ...action.payload,
                },
                isLoading: false,
            };
        }

        case GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: true },
            };
        case GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS:
            return {
                ...state,
                activeReports: { reports: getActiveReports(action.payload) },
            };
        case GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR:
            return {
                ...state,
                activeReports: { ...action.payload },
            };

        case RESET_PAYMENT_GATEWAY_CREDENTIAL_CREATE_FORM: {
            return {
                ...state,
                createFormData: {
                    ...initialState.createFormData,
                    referenceId: state.createFormData?.referenceId,
                },
                //draftData:[],
            };
        }

        case RESET_PAYMENT_GATEWAY_CREDENTIAL_EDIT_DATA_ON_CREATE_FORM: {
            return {
                ...state,
                createFormData: {
                    ...initialState.createFormData,
                    referenceId: state.createFormData?.referenceId,
                },
                draftData: [],
            };
        }

        case RESET_PAYMENT_GATEWAY_CREDENTIAL_UPDATE_FORM: {
            return {
                ...state,
                editFormData: {
                    ...initialState.editFormData,
                    referenceId: state.editFormData?.referenceId,
                },
            };
        }

        case CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST: {
            return {
                ...state,
                createFormData: {
                    ...state.createFormData,
                    isLoading: true,
                    isSuccess: false,
                    sectionType: action.sectionType,
                },
            };
        }
        case CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS: {
            console.log("CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS", action);
            let updatedDraftData = [];
            if (action.sectionType === 'paymodeSection') {
                let payModeDraftData = [];
                if (action?.requestPayload?.paymentModeSection) {
                    const prePayMode = state.draftData.find(item => item.type === "paymodeSection");
                    // console.log("action.requestPayload", action.requestPayload);
                    let payModeData = getPaymodeFormValuesFromResponse(
                        action.requestPayload.paymentModeSection?.paymentModeDetails || []
                    );
                    console.log("paymoddata", payModeData, prePayMode);
                    if (prePayMode) {
                        payModeDraftData = state.draftData.map(item => {
                            if (item.type === "paymodeSection") {
                                return { ...item, data: payModeData };
                            }
                            return item;
                        })
                    } else {
                        payModeDraftData = [
                            ...state.draftData,
                            { type: 'paymodeSection', data: payModeData },
                        ];
                    }
                } else {
                    payModeDraftData = [...state.draftData];
                }

                const initPricingValue = getPricingInitValue(
                    action.formSectionData
                );
                // console.log("initpricing value", initPricingValue);

                // console.log("create init pricing section", initPricingValue);

                // and we will use that data to pouplate draftdata
                let pricingInitData = { feeConfigList: initPricingValue };

                let filteredPayModeDraftData = payModeDraftData.filter(item => item.type !== "pricingSection");

                updatedDraftData = [
                    ...filteredPayModeDraftData,
                    { type: 'pricingSection', data: pricingInitData },
                ];
            } else if (action.sectionType === "credentialSection") {
                const preData = state.draftData.find(item => item.type === "credentialSection");


                if (preData) {
                    updatedDraftData = state.draftData.map(item => {
                        if (item.type === "credentialSection") {
                            return { ...item, data: action.formSectionData };
                        }
                        return item;
                    })
                } else {
                    updatedDraftData = [
                        ...state.draftData,
                        { type: 'credentialSection', data: action.formSectionData },
                    ];
                }
            }
            // console.log("CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS...");
            // console.log("state.createFormData", state.createFormData);
            // console.log("action.payload", action.payload);
            let referenceId = action.payload?.referenceId
            ? action.payload.referenceId
            : state.createFormData.referenceId;
            if (action.sectionType === 'pricingSection') {
                referenceId = '';
            }

            return {
                ...state,
                draftData: updatedDraftData || [],
                createFormData: {
                    ...state.createFormData,
                    isLoading: false,
                    isSuccess: true,
                    sectionType: action.sectionType,
                    referenceId,
                },
            };
        }
        case CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR: {
            return {
                ...state,
                createFormData: {
                    ...state.createFormData,
                    isLoading: false,
                    isSuccess: false,
                    sectionType: action.sectionType,
                    referenceId: action?.payload?.referenceId,
                    error: { ...action.payload },
                },
            };
        }

        case UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR: {
            return {
                ...state,
                editFormData: {
                    ...state.editFormData,
                    isLoading: false,
                    isSuccess: false,
                    sectionType: action.sectionType,
                    referenceId: action?.payload?.referenceId,
                    error: { ...action.payload },
                },
            };
        }

        case UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS: {
            let updatedDraftData = [];

            if (action.sectionType === 'paymodeSection') {

                let pricingInitData = getPricingFormValuesFromResponse(
                    action.formSectionData,
                    state.editFormData.pgMIDFeeInfoResponse
                );

                const initPricingValue = getPricingInitValue(
                    action.formSectionData
                );

                let pricingInitData2 = { feeConfigList: initPricingValue };

                updatedDraftData = state.draftData.some(item => item.type === 'pricingSection')
                    ? state.draftData.map(item =>
                        item.type === 'pricingSection'
                            ? { ...item, data: !state.editFormData.pgMIDFeeInfoResponse ? pricingInitData2 : pricingInitData }
                            : item
                    )
                    : [
                        ...state.draftData,
                        { type: 'pricingSection', data: !state.editFormData.pgMIDFeeInfoResponse ? pricingInitData2 : pricingInitData }
                    ];
                    console.log("updatedDraftData", updatedDraftData);
            }
            // console.log("UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS...");
            return {
                ...state,
                draftData: updatedDraftData || [],
                editFormData: {
                    ...state.editFormData,
                    isLoading: false,
                    isSuccess: true,
                    sectionType: action.sectionType,
                    referenceId: !state.editFormData.referenceId
                        ? action.payload.referenceId
                        : state.editFormData.referenceId,
                },
            };
        }

        case UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST: {

            return {
                ...state,
                editFormData: {
                    ...state.editFormData,
                    isLoading: true,
                    isSuccess: false,
                    sectionType: action.sectionType,
                },
            };
        }

        case FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_REQUEST: {
            return {
                ...state,
                isLoading: true,
                editFormData: initialState.editFormData,
                // draftData: [],
            };
        }

        case FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_ERROR: {

            return {
                ...state,
                editFormData: initialState.editFormData,
                isLoading: false,
                draftData: [],
            };
        }
        case FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_SUCCESS: {

            // console.log("acction payload", action.payload);
            const formDraftData = getEditDraftData(action.payload) || [];

            const hasPricing = formDraftData.findIndex(item => item.type === "pricingSection");
            const preData = state.draftData.find(item => item.type === "pricingSection")

            // console.log("FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_SUCCESS...");
            return {
                ...state,
                isLoading: false,
                editFormData: {
                    ...state.editFormData,
                    isLoading: false,
                    isSuccess: true,
                    referenceId: action?.payload?.referenceId,
                    pgMIDFeeInfoResponse: action?.payload?.pgMIDFeeInfoResponse,
                },
                draftData: hasPricing === -1 && preData ? state.draftData.map(item => {
                    if(item.type === "pricingSection"){
                        return preData;
                    }
                    return formDraftData.find(nesItem  => nesItem.type === item.type)
                }) : formDraftData,
            };
        }
        case SHOW_ROLE_LOADER:
            return { ...state, isLoading: true };
        case HIDE_ROLE_LOADER:
            return { ...state, isLoading: false };
        case FETCH_FORM_DATA_PRICING_SECTION_SUCCESS:
            return { ...state, pricing_section_initial_data: {...action.payload, isSuccess: true},  isLoading: false };
        case FETCH_FORM_DATA_PRICING_SECTION_FAILED:
            return { ...state, pricing_section_initial_data: {...action.payload, isSuccess: true}, isLoading: false }
        case CLICKED_CREATE_PAYMENT_CREADENTIAL_FORM:
            return {
                ...state,
                createFormData: {
                    ...state.createFormData,
                    referenceId: '',
                },
            };
        default:
            return state;
    }
};
